// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AgAj","colBig":"styles_colBig__3Y45N","colSmall":"styles_colSmall__2EswU","shopifyNameWrapper":"styles_shopifyNameWrapper__264KV"};